import React, { useState } from "react";
import {
  Row,
  Col,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap";

import { plan as p } from "@/utils/content";
import pricingData from "@/data/pricing.json";

const PlanFaqs = () => {
  const content = p.en;

  const [open, setOpen] = useState("1");

  const toggle = (id: any) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <section className="my-5 container py-5" id="faqs-section">
      <Row>
        <Col xs={12} lg={3}>
          <h3>{content.faqTitle}</h3>
          <p>{content.faqPara1}</p>
          <p>
            {content.faqPara2} <a href={content.email}>{content.reachOut}</a>
          </p>
        </Col>
        <Col xs={12} lg={9}>
          <Accordion
            open={open}
            //@ts-ignore
            toggle={toggle}
          >
            {pricingData.faq?.map((faq, i) => {
              return (
                <AccordionItem key={i}>
                  <AccordionHeader targetId={(i + 1).toString()}>
                    {faq.name}
                  </AccordionHeader>
                  <AccordionBody accordionId={(i + 1).toString()}>
                    {faq.desc}
                  </AccordionBody>
                </AccordionItem>
              );
            })}
          </Accordion>
        </Col>
      </Row>
    </section>
  );
};

export default PlanFaqs;
